import { useEffect, useState, useCallback, useMemo } from 'react';
import { attempt, isBoolean } from 'lodash/fp';
import { debounce } from 'app/lib/fp';

const toggleBySetter = (setFn) => (nextValue) =>
    setFn((currentValue) => Boolean(isBoolean(nextValue) ? nextValue : !currentValue));

export function useToggleState(initialValue, { debounced, delay = 2 } = {}) {
    const [value, setValue] = useState(initialValue);
    const toggle = useMemo(
        () =>
            !debounced ? toggleBySetter(setValue) : debounce(null, delay, toggleBySetter(setValue)),
        [debounced, delay]
    );

    const on = useCallback(() => toggle(true), [toggle]);

    const off = useCallback(() => toggle(false), [toggle]);

    useEffect(() => () => attempt(toggle.cancel), [toggle]);

    return [value, toggle, on, off];
}
